var module = angular.module('octopusApp.accounts');

module.directive('sshKeyPairAccount', function() {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      account: '=model'
    },
    templateUrl: 'areas/accounts/views/ssh_key_pair_account.html',
    link: function(scope) {
      var link = function() {
        if (!scope.account.PrivateKeyFile) {
          scope.account.PrivateKeyFile = { HasValue: false };
        }
        if (!scope.account.PrivateKeyPassphrase) {
          scope.account.PrivateKeyPassphrase = { HasValue: false };
        }
      };

      if (scope.account) {
        link();
      } else {
        var unwatch = scope.$watch('account', function(nv) {
          if (nv && !scope.view) {
            link();
            unwatch();
          }
        });
      }
    }
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/accounts/directives/ssh_key_pair_account.js
// module id = 375
// module chunks = 1